import React from 'react';
import VoterLocBlock from '../Utils/VoterLocation';
import {getLabel} from "../../language";

class VoterLocationsTab extends  React.Component {
  constructor(props) {
    super(props);

    this.state = {locations: []};
    this.submitForm = this.submitForm.bind(this);
    this.onLocationSelect = this.onLocationSelect.bind(this);
  }

  onLocationSelect(locations) {
    this.setState({...this.state, locations: locations});
  }

  submitForm(ev) {
    ev.preventDefault();
  };

  render() {
    return (
      <div>
        <form onSubmit={this.submitForm}>
          <div className="row">
            <div className="col-md-12">
              <div className={`alert alert-warning ${this.props.currentUser && this.props.currentUser.hasVoterLocations ? 'hidden' : ''}`}
                   role="alert">{getLabel(197)}
              </div>
            </div>
          </div>
          <VoterLocBlock onVoterLocationAdded={this.props.onVoterLocationAdded} currentUser={this.props.currentUser} fetchUser={this.props.fetchUser} multiForms={true} onLocationSelect={this.onLocationSelect} fillLocation={true}/>
        </form>
      </div>
    )
  }
}

export default VoterLocationsTab;
